<template>
  <div class="tn-game">
    <v-row no-gutters>
      <v-col
          v-for="game in games" :key="game.id"
          cols="12 col-sm-6 col-md-4 col-lg-3">
        <v-card class="game-card" >
          <v-card-title>{{ game.name }}</v-card-title>
          <v-card-subtitle>{{ game.players.map(({name})=>name).join(',')}}</v-card-subtitle>
          <v-card-actions>
            <v-btn color="success" @click="goIntoItem(game)">참가하기</v-btn>
            <v-btn color="error" outlined @click.stop="deleteItem(game)">삭제하기</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12 col-sm-6 col-md-4 col-lg-3">
        <v-card class="game-card d-flex centered" @click="addItem">
          <v-icon>mdi-plus</v-icon>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {createGame, deleteGame, getGames} from "@/api/game";

export default {
  name: "Games",
  data(){
    return {
      games: []
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    goIntoItem({id}){
      return this.$router.push({name: 'Game',params: {id}})
    },
    async deleteItem(game){
      await this.$confirm('게임을 정말 삭제합니까?\n반영되지 않은 기록은 삭제됩니다.', '게임삭제','error')
      await deleteGame(game.id)
      this.getItems()
    },
    async addItem(){
      await this.$confirm('게임을 만드시겠습니까?', '게임생성','question')
      const result = await createGame({name: this.$day().dateFormat()+' 게임'})

      if(result.insertId >= 0){
        await this.$confirm('게임으로 이동하시겠습니까?','생성완료','question')
        return this.goIntoItem({id: result.insertId})
      }
      this.getItems()
    },
    getItems(){
      return getGames().then(games => {
        this.games = games
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tn-game{
  .game-card{
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 200px;
  }
}
</style>